// Helpers of loading component

import variables from "styles/util/variables";

export const backdropConfig = {
  opacity: 1,
  color: variables.palette["black-s2-l17"]
};
